import PropTypes from 'prop-types';
import React from 'react';
import shelfCss from './PartnerConfigurationShelf.css';
import { ParameterTypes, partnerShape, TemplateTypes } from '../types';
import { FACEBOOK_PARTNER_NAME, GOOGLE_ADWORDS_PARTNER_NAME } from '../../consts';
import { OS } from '../../../utils/OS';
import { getTemplate, getUsedParameters } from './utils';
import PartnerSetupInformation from './PartnerSetupInformation';
import PartnerParameters from './partnerParameters/PartnerParameters';

// partner name to list of messages
const PARTNER_INFO_MSG = {
    [FACEBOOK_PARTNER_NAME]: {
        [OS.IOS]: [
            'STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.FACEBOOK_SETUP_INFORMATION',
            'STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.FACEBOOK_AMM_INFORMATION',
        ],
        [OS.ANDROID]: ['STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.FACEBOOK_AMM_INFORMATION'],
    },
    [GOOGLE_ADWORDS_PARTNER_NAME]: {
        [OS.IOS]: ['STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.GOOGLE_ADWORDS_SETUP_INFORMATION'],
        [OS.ANDROID]: [
            'STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.GOOGLE_ADWORDS_SETUP_INFORMATION',
        ],
    },
};

function PartnerSetupSection({ partner, platform, isReadonly }) {
    const parameters = getUsedParameters(
        partner,
        platform,
        getTemplate(partner, platform, TemplateTypes.INSTALL) ? TemplateTypes.INSTALL : TemplateTypes.CUSTOM,
        [ParameterTypes.ACCOUNT, ParameterTypes.APPLICATION]
    );

    const messages = PARTNER_INFO_MSG?.[partner.name]?.[platform];

    // check if there is no content to the child components
    if (parameters.length === 0 && (!messages || messages.length === 0)) {
        return null;
    }

    return (
        <div className={shelfCss.section}>
            <PartnerParameters parameters={parameters} partner={partner} isReadonly={isReadonly} />
            <PartnerSetupInformation messages={messages} />
        </div>
    );
}

PartnerSetupSection.propTypes = {
    partner: partnerShape.isRequired,
    platform: PropTypes.string,
    isReadonly: PropTypes.bool,
};

export default PartnerSetupSection;
